import React from 'react'
import Dashboard from '../../dashboard/components/Dashboard'

const Login = () => {
  return (
    <div align="center">
      <h1 >YAARI INFINTY</h1>
      <Dashboard/>
    </div>
  )
}

export default Login